import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/store/auth'
import { toast } from 'vue3-toastify'

export const routes = [
  {
    path: '/',
    redirect: '/home',
    component: () => import('@/layouts/landing-page-layouts.vue'),
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/pages/landing-page.vue'),
      },
      {
        path: 'testimonial',
        name: 'testimonial',
        component: () => import('@/pages/landing-page.vue'),
      },
      {
        path: 'how-it-works',
        name: 'how it works',
        component: () => import('@/pages/landing-page.vue'),
      },
      {
        path: 'about',
        name: 'about',
        component: () => import('@/views/pages/landing-page/AboutAgroTrade.vue'),
      },
      {
        path: 'contact',
        name: 'contact',
        component: () => import('@/views/pages/landing-page/Contact.vue'),
      },
      {
        path: 'news-feed',
        name: 'news-feed',
        component: () => import('@/views/pages/landing-page/NewsFeed.vue'),
      },
      {
        path: 'privacy-policy',
        name: 'privacy-policy',
        component: () => import('@/views/pages/landing-page/PrivacyPolicy.vue'),
      },
      {
        path: 'terms-of-service',
        name: 'terms-of-service',
        component: () => import('@/views/pages/landing-page/TermsOfService.vue'),
      },
      {
        meta: {
          title: 'Agro Market',
          requiresAuth: true,
        },
        path: '/agro-market',
        name: 'agro-market',
        component: () => import('@/views/pages/landing-page/AgroMarket.vue'),
      },
      {
        meta: {
          title: 'Categories',
          requiresAuth: true,
        },
        path: '/categories/',
        name: 'categories',
        component: () => import('@/views/pages/landing-page/Categories.vue'),
      },
      {
        meta: {
          title: 'Animal Feeds',
          requiresAuth: true,
        },
        path: 'categories/animal feeds',
        name: 'animal feeds',
        component: () => import('@/views/pages/categories/Animal Feeds.vue'),
      },
      {
        meta: {
          title: 'Bakery',
          requiresAuth: true,
        },
        path: 'categories/bakery',
        name: 'bakery',
        component: () => import('@/views/pages/categories/Bakery.vue'),
      },
      {
        meta: {
          title: 'Beverages',
          requiresAuth: true,
        },
        path: 'categories/beverages',
        name: 'beverages',
        component: () => import('@/views/pages/categories/Beverages.vue'),
      },
      {
        meta: {
          title: 'Cereals',
          requiresAuth: true,
        },
        path: 'categories/cereals',
        name: 'cereals',
        component: () => import('@/views/pages/categories/Cereals.vue'),
      },
      {
        meta: {
          title: 'Diary',
          requiresAuth: true,
        },
        path: 'categories/diary',
        name: 'diary',
        component: () => import('@/views/pages/categories/Diary.vue'),
      },
      {
        meta: {
          title: 'Fibers',
          requiresAuth: true,
        },
        path: 'categories/fibers',
        name: 'fibers',
        component: () => import('@/views/pages/categories/Fibers.vue'),
      },
      {
        meta: {
          title: 'Grains',
          requiresAuth: true,
        },
        path: 'categories/grains',
        name: 'grains',
        component: () => import('@/views/pages/categories/Grains.vue')
      },
      {
        meta: {
          title: 'Fruits',
          requiresAuth: true,
        },
        path: 'categories/fruits',
        name: 'fruits',
        component: () => import('@/views/pages/categories/Fruits.vue'),
      },
      {
        meta: {
          title: 'Legumes',
          requiresAuth: true,
        },
        path: 'categories/legumes',
        name: 'legumes',
        component: () => import('@/views/pages/categories/Legumes.vue'),
      },
      {
        meta: {
          title: 'Meat And SeaFood',
          requiresAuth: true,
        },
        path: 'categories/meat_seafood',
        name: 'meat and seafood',
        component: () => import('@/views/pages/categories/MeatAndSeaFood.vue'),
      },
      {
        meta: {
          title: 'Narcotics',
          requiresAuth: true,
        },
        path: 'categories/narcotics',
        name: 'narcotics',
        component: () => import('@/views/pages/categories/Narcotics.vue'),
      },
      {
        meta: {
          title: 'Nuts',
          requiresAuth: true,
        },
        path: 'categories/nuts',
        name: 'nuts',
        component: () => import('@/views/pages/categories/Nuts.vue'),
      },
      {
        meta: {
          title: 'Oilseed',
          requiresAuth: true,
        },
        path: 'categories/oilseed',
        name: 'oilseed',
        component: () => import('@/views/pages/categories/Oilseeds.vue'),
      },
      {
        meta: {
          title: 'Rubber',
          requiresAuth: true,
        },
        path: 'categories/rubber',
        name: 'rubber',
        component: () => import('@/views/pages/categories/Rubber.vue'),
      },
      {
        meta: {
          title: 'Seeds',
          requiresAuth: true,
        },
        path: 'categories/seed',
        name: 'seed',
        component: () => import('@/views/pages/categories/Seeds.vue'),
      },
      {
        meta: {
          title: 'Spices',
          requiresAuth: true,
        },
        path: 'categories/spices',
        name: 'spices',
        component: () => import('@/views/pages/categories/Spices.vue'),
      },
      {
        meta: {
          title: 'Starch',
          requiresAuth: true,
        },
        path: 'categories/starch',
        name: 'starch',
        component: () => import('@/views/pages/categories/Starches.vue'),
      },
      {
        meta: {
          title: 'Sugar',
          requiresAuth: true,
        },
        path: 'categories/sugar',
        name: 'sugar',
        component: () => import('@/views/pages/categories/Sugar.vue'),
      },
      {
        meta: {
          title: 'Vegetables',
          requiresAuth: true,
        },
        path: 'categories/vegetables',
        name: 'vegetables',
        component: () => import('@/views/pages/categories/Vegetables.vue'),
      },
    ],
  },
  {
    path: '/',
    component: () => import('@/layouts/default.vue'),
    beforeEnter: (to, from, next) => {
      const authStore = useAuthStore()
      if (authStore.checkAuth()) {
        next()
      } else {
        toast.info("You are not Logged In")
        next({ name: 'login'})
      }
    },
    children: [
      {
        meta: {
          title: 'Dashboard',
          requiresAuth: true,
        },
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/pages/dashboard.vue'),
      },
      {
        meta: {
          title: 'Account Settings',
          requiresAuth: true,
        },
        path: '/account-settings',
        name: 'account-settings',
        component: () => import('@/pages/account-settings.vue'),
      },
      {
        meta: {
          title: 'Profile',
          requiresAuth: true,
        },
        path: 'profile',
        name: 'profile',
        component: () => import('@/pages/profile.vue'),
      },
      {
        meta: {
          title: 'Create New Ads',
          requiresAuth: true,
        },
        path: 'create-new-ads',
        name: 'create-new-ads',
        component: () => import('@/views/pages/Ads/CreateNewAds.vue'),
      },

      {
        meta: {
          title: 'Request Ads',
          requiresAuth: true,
        },
        path: 'request-ads',
        name: 'request-ads',
        component: () => import('@/views/pages/Ads/RequestAds.vue'),
      },
      {
        meta: {
          title: 'Ads History',
          requiresAuth: true,
        },
        path: 'my-ads-history',
        name: 'my-ads-history',
        component: () => import('@/views/pages/Ads/MyAdsHistory.vue'),
      },
      {
        meta: {
          title: 'Agro Market',
          requiresAuth: true,
        },
        path: 'agro-market',
        name: 'agro-market',
        component: () => import('@/views/pages/Ads/Agro Market.vue'),
      },
      {
        meta: {
          title: 'Ads Details',
          requiresAuth: true,
        },
        path: '/ads-details/:uuid',
        name: 'ads-details',
        component: () => import('@/views/pages/Ads/AdDetails.vue'),
        props: true
      },
      {
        meta: {
          title: 'Ads Review',
          requiresAuth: true,
        },
        path: '/ads-review/:uuid',
        name: 'ads-review',
        component:() => import('@/views/pages/Ads/AdsReview.vue'),
        props: true
      },
      {
        meta: {
          title: 'Messages',
          requiresAuth: true,
        },
        path: 'messages',
        name: 'messages',
        component: () => import('@/pages/messages.vue'),
      },
      {
        meta: {
          title: 'Faq',
        },
        path: 'faq',
        name: 'faq',
        component: () => import('@/pages/landing_page_faq.vue'),
      },
      {
        meta: {
          title: 'Create Support Ticket',
        },
        path: 'create-support-ticket',
        name: 'create-support-ticket',
        component: () => import('@/views/pages/support/CreateSupportTicket.vue'),
      },
      {
        meta: {
          title: 'My Support Ticket',
        },
        path: 'my-support-ticket',
        name: 'my-support-ticket',
        component: () => import('@/views/pages/support/MySuuportTicket.vue'),
      },
      {
        meta: {
          title: 'Announcement',
        },
        path: 'announcement',
        name: 'announcement',
        component: () => import('@/views/pages/support/Announcement.vue'),
      },
    ],
  },
  {
    path: '/',
    component: () => import('@/layouts/blank.vue'),
    children: [
      {
        meta: {
          title: 'Login',
        },
        path: 'login',
        name: 'login',
        component: () => import('@/pages/login.vue'),
      },
      {
        meta: {
          title: 'Register',
        },
        path: 'register',
        name: 'register',
        component: () => import('@/pages/register.vue'),
      },
      {
        meta: {
          title: 'Verify Email',
        },
        path: 'verify-email',
        name: 'verify-email',
        component: () => import('@/pages/verify-email.vue'),
      },
      {
        meta: {
          title: 'Forgot Password',
        },
        path: 'forgot-password',
        name: 'forgot-password',
        component: () => import('@/pages/forgot-password.vue'),
      },
      {
        meta: {
          title: 'Reset Password',
        },

        // path: '/reset-password?token={token}.&email={email}',
        path: 'reset-password/:token',
        name: 'reset-password',
        component: () => import('@/pages/reset-password.vue'),
      },
      {
        path: '/:pathMatch(.*)*',
        component: () => import('@/pages/[...error].vue'),
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
